
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise/puroclean",
      function () {
        return require("private-next-pages/franchise/puroclean/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/franchise/puroclean"])
      });
    }
  